import type { HTMLAttributes } from "react";
import { TOOFI_CARD_VARIANT_CLASS } from "@/lib/toofi-ux-tokens";
import { cn } from "@/lib/utils";

export type ToofiCardVariant = "shell" | "artifact" | "entry" | "meta";

type ToofiCardProps = HTMLAttributes<HTMLDivElement> & {
  variant?: ToofiCardVariant;
  compactPhone?: boolean;
};

export function ToofiCard({ variant = "shell", compactPhone = false, className, ...props }: ToofiCardProps) {
  return (
    <div
      className={cn(
        TOOFI_CARD_VARIANT_CLASS[variant],
        compactPhone && "rounded-[1.2rem] px-0 shadow-[0_10px_24px_rgba(15,23,42,0.05)] sm:rounded-[1.35rem]",
        className,
      )}
      {...props}
    />
  );
}
